import {createContext} from "react"

export const UserContext = createContext({user:{id:'',first_name:'', last_name:'', auth_token:'', role: ''}, setUser:()=>{}});

